import React, { useEffect, useState } from 'react'
import { getStudioConfigAPI } from '../../../Redux/ApiCalls/Dashboard/StudioConfig';
import { LANDING_PAGE } from '../../../config/config';
import LoadingDots from '../../atoms/Utlis/LoadinDots';
import QRCode from "react-qr-code";
import StudioWebsiteForm from './StudioWebsiteForm';
import { PreviewWebsite } from '../../molecules/Dashboard/PreviewWebsite/PreviewWebsite';
import { Copy, Edit } from 'lucide-react';
import GradientFillButton from '../../atoms/Utlis/GradientFillButton';

const StudioWebsitePage = () => {
    const [config, setConfig] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [studioUrl, setStudioUrl] = useState<string>();
    const [isEdit, setIsEdit] = useState(false);
    const [isDataUpdated, setIsDataUpdated] = useState(true);

    useEffect(() => {
        if (!isDataUpdated) return;

        setLoading(true);
        getStudioConfigAPI()
            .then((res) => {
                const cfg = res?.data?.studio_configuration;

                if (cfg) {
                    setConfig(cfg);
                    setStudioUrl(`${LANDING_PAGE}/${cfg.slug}`);
                    return;
                }

                // No config returned → ensure we reset local state
                setConfig(undefined);
                setStudioUrl(undefined);
                setIsEdit(false);
            })
            .catch(() => {
                setConfig(undefined);
                setStudioUrl(undefined);
                setIsEdit(false);
            })
            .finally(() => {
                setIsDataUpdated(false);
                setLoading(false);
            });
    }, [isDataUpdated]);

    const handleCopy = () => {
        if (studioUrl) navigator.clipboard.writeText(studioUrl);
    }
    const isConfigEmpty = !config || Object.keys(config).length === 0;

    return (
        <>
            {loading ? (
                <div className="h-screen w-full flex justify-center items-center">
                    <LoadingDots />
                </div>
            ) : (
                <>
                    {/* {config && !isEdit ? (
                        <div className="p-4 space-y-6">
                            <div className="flex flex-col md:flex-row md:items-center gap-6 border p-4 rounded-xl shadow-sm bg-white">
                                <div className="flex justify-center">
                                    {studioUrl && <QRCode value={studioUrl} size={140} />}
                                </div>

                                <div className="flex-1 space-y-2">
                                    <p className="text-sm text-gray-600">Your Studio Link:</p>
                                    <p className="text-lg font-medium break-all">{studioUrl}</p>

                                    <div className="flex gap-3 mt-2">


                                        <GradientFillButton
                                            onClick={() => setIsEdit(true)}
                                            className="flex items-center gap-2 px-4 py-2 text-sm bg-blue-600 text-white hover:bg-blue-700 rounded-lg"
                                        >
                                            <Edit size={16} /> Edit Website
                                        </GradientFillButton>
                                    </div>
                                </div>
                            </div>
                            <div className='bg-white p-4 rounded-xl '>
                                <p className='text-xl font-semibold mb-4 text-center '>Preview </p>
                                <PreviewWebsite data={config} />
                            </div>
                        </div>
                    ) : (
                        <StudioWebsiteForm studioConfig={config} isEdit={isEdit} setIsDataUpdate={setIsDataUpdated} setIsEdit={setIsEdit} />
                    )} */}
                    {/* 1️ If config does NOT exist → First time user → Show Form */}
                    {isConfigEmpty ? (
                        <StudioWebsiteForm
                            studioConfig={config}
                            isEdit={false}
                            setIsDataUpdate={setIsDataUpdated}
                            setIsEdit={setIsEdit}
                        />
                    ) : (

                        /* 2️ If config exists AND not editing → Show Preview */
                        !isEdit ? (
                            <div className="p-4 space-y-6">
                                <div className="flex flex-col md:flex-row md:items-center gap-6 border p-4 rounded-xl shadow-sm bg-white">
                                    <div className="flex flex-col items-center gap-2">
                                        <p className="text-sm font-medium text-gray-600">Scan to open</p>
                                        {studioUrl && <QRCode value={studioUrl} size={140} />}
                                    </div>

                                    <div className="flex-1 space-y-3">
                                        <p className="text-sm text-gray-600">Your Studio Link</p>
                                        <p className="text-lg font-medium break-all">{studioUrl}</p>

                                        <div className="flex flex-wrap gap-3 mt-2">
                                            <GradientFillButton
                                                onClick={handleCopy}
                                                className="flex items-center gap-2 px-4 py-2 text-sm"
                                            >
                                                <Copy size={16} /> Copy Link
                                            </GradientFillButton>

                                            <GradientFillButton
                                                onClick={() => setIsEdit(true)}
                                                className="flex items-center gap-2 px-4 py-2 text-sm bg-blue-600 text-white hover:bg-blue-700 rounded-lg"
                                            >
                                                <Edit size={16} /> Edit Website
                                            </GradientFillButton>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white p-4 rounded-xl">
                                    <p className="text-xl font-semibold mb-4 text-center">Preview</p>
                                    <PreviewWebsite data={config} />
                                </div>
                            </div>

                        ) : (

                            /* 3️ Editing mode → Show Form */
                            <StudioWebsiteForm
                                studioConfig={config}
                                isEdit={true}
                                setIsDataUpdate={setIsDataUpdated}
                                setIsEdit={setIsEdit}
                            />
                        )
                    )}

                </>
            )}
        </>
    );
};

export default StudioWebsitePage;
